import script from "./share.vue?vue&type=script&setup=true&lang=js"
export * from "./share.vue?vue&type=script&setup=true&lang=js"

import "./share.vue?vue&type=style&index=0&id=f8b1b35a&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8b1b35a"]])

export default __exports__